import React, { Component } from 'react';
import i18n from 'utils/translate';

const defaultProps = {
  address: null,
  contacts: null,
  lat: null,
  lon: null,
  customHeadline: null
};

class Address extends Component {
  render() {
    const { address, contacts, lat, lon } = this.props;

    return (
      <div className="address-hours">
        <div>{this.renderAddress(address, lat, lon)}</div>
        <div>{this.renderContacts(contacts)}</div>
      </div>
    );
  }

  renderAddress(address, lat, lon) {
    return (
      <div className="row row-no-gutters">
        <div className="col-xs-1">
          <i className="icon-pin"></i>
        </div>
        <div className="col-xs-11">
          {this.props.customHeadline ? (
            <div>
              <strong>{this.props.customHeadline}</strong>
              <br />
              {address.street}
            </div>
          ) : (
            <div>
              <strong>{address.street}</strong>
            </div>
          )}
          <div className="contact-ellipsis">
            {address.zip} {address.city}
          </div>
          <a
            className="office__person-directions"
            href={`https://www.google.com/maps/dir/?api=1&destination=${lat},${lon}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {i18n('directions')}
          </a>
        </div>
      </div>
    );
  }

  renderContacts(contacts) {
    const phoneLink = contacts.phone ? contacts.phone.replace(/ /g, '') : '';
    const phone = contacts.phone ? (
      <div className="row row-no-gutters">
        <div className="col-xs-1">{i18n('phone')}</div>
        <div className="col-xs-10 contact-ellipsis">
          <a href={`tel:${phoneLink}`}>{contacts.phone}</a>
        </div>
      </div>
    ) : null;
    const mobLink = contacts.mob ? contacts.mob.replace(/ /g, '') : '';
    const mob = contacts.mob ? (
      <div className="row row-no-gutters">
        <div className="col-xs-1">{i18n('phone-alt')}</div>
        <div className="col-xs-10 contact-ellipsis">
          <a href={`tel:${mobLink}`}>{contacts.mob}</a>
        </div>
      </div>
    ) : null;
    const faxLink = contacts.fax ? contacts.fax.replace(/ /g, '') : '';
    const fax = contacts.fax ? (
      <div className="row row-no-gutters">
        <div className="col-xs-1">{i18n('fax')}</div>
        <div className="col-xs-10 contact-ellipsis">
          <a href={`tel:${faxLink}`}>{contacts.fax}</a>
        </div>
      </div>
    ) : null;
    const email = contacts.email ? (
      <div className="row row-no-gutters">
        <div className="col-xs-1">{i18n('email')}</div>
        <div className="col-xs-10 contact-ellipsis">
          <a href={`mailto:${contacts.email}`}>{contacts.email}</a>
        </div>
      </div>
    ) : null;
    return (
      <div>
        {phone}
        {mob}
        {fax}
        {email}
      </div>
    );
  }
}

Address.defaultProps = defaultProps;

export default Address;
